var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconTripDgestination64X64(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "streamline-icon-trip-destination_64x64",
    "data-name": "streamline-icon-trip-destination@64x64",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    "data-name": "Path 820",
    d: "M75.333,18.667c0,7.556-11.276,25.236-15.276,31.271a1.667,1.667,0,0,1-2.778,0C53.276,43.907,42,26.222,42,18.667a16.667,16.667,0,1,1,33.333,0Z",
    transform: "translate(26.667 0)",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    d: "M52,11a1.667,1.667,0,0,1,1.667,1.667",
    transform: "translate(33.333 6)",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    d: "M51,12.667A1.667,1.667,0,0,1,52.667,11",
    transform: "translate(32.667 6)",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    d: "M52.667,13.667A1.667,1.667,0,0,1,51,12",
    transform: "translate(32.667 6.667)",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    "data-name": "Path 824",
    d: "M53.667,12A1.667,1.667,0,0,1,52,13.667",
    transform: "translate(33.333 6.667)",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    d: "M14,33a1.667,1.667,0,0,1,1.667,1.667",
    transform: "translate(8 20.667)",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    d: "M13,34.667A1.667,1.667,0,0,1,14.667,33",
    transform: "translate(7.333 20.667)",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    d: "M14.667,35.667A1.667,1.667,0,0,1,13,34",
    transform: "translate(7.333 21.333)",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    "data-name": "Path 828",
    d: "M15.667,34A1.667,1.667,0,0,1,14,35.667",
    transform: "translate(8 21.333)",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    d: "M22,22A20,20,0,0,1,42,42c0,8.538-11.947,24.782-17.373,31.724a3.333,3.333,0,0,1-5.253,0C13.947,66.787,2,50.538,2,42A20,20,0,0,1,22,22Z",
    transform: "translate(0 13.333)",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    "data-name": "Path 830",
    d: "M14,75.333H54a6.667,6.667,0,0,0,6.667-6.667v-20A6.667,6.667,0,0,1,67.333,42H80.667",
    transform: "translate(8 26.667)",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconTripDgestination64X64);
export default __webpack_public_path__ + "static/media/streamline-icon-trip-dgestination@64x64.664fbc95.svg";
export { ForwardRef as ReactComponent };